module.exports = __webpack_public_path__ + "media/images/languages-da077cb813c2896861e1f9ee076118b0.png";